import { Breadcrumb as AntBreadcrumb } from 'antd';
import { Link } from 'react-router-dom';
// import { useLanguage } from '@/contexts/LanguageContext';
import { RightOutlined } from '@ant-design/icons';

export interface BreadcrumbItem {
  label: string; // pagetitle key or plain text
  path?: string; // route path (if not provided, treated as current page)
  isTranslatable?: boolean; // if true, label will be translated using pagetitle
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

/**
 * Breadcrumb component with i18n support
 * Uses pagetitle keys for translation
 * @example
 * <Breadcrumb items={[
 *   { label: 'dashboard', isTranslatable: true, path: ROUTER.DASHBOARD() },
 *   { label: 'product_management', isTranslatable: true, path: ROUTER.PRODUCT_MANAGEMENT() },
 *   { label: productName } // current page, no translation
 * ]} />
 */
export default function Breadcrumb({ items }: BreadcrumbProps) {
  // const { translate } = useLanguage();

  const breadcrumbItems = items.map((item, index) => {
    const isLast = index === items.length - 1;
    const label = item.isTranslatable ? `pagetitle.${item.label}` : item.label;

    if (isLast || !item.path) {
      return {
        title: <span className="form-field-label text-gray-900">{label}</span>,
      };
    }

    return {
      title: (
        <Link
          to={item.path}
          className="form-field-label text-gray-700 transition-colors hover:text-gray-900"
        >
          {label}
        </Link>
      ),
    };
  });

  return (
    <AntBreadcrumb
      items={breadcrumbItems}
      className="mb-0!"
      separator={
        <span className="px-1.5 text-gray-400 font-semibold">
          <RightOutlined />
        </span>
      }
    />
  );
}
